import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import Button from 'components/formElements/Button'
import React, { useEffect, useState } from 'react'
import Icons from 'assets/icons'
import * as FileSaver from 'file-saver'

const LeavesReport = () => {
    const [getDevelopers, getDevelopersLoading] = useRequest()
    const [developers, setDevelopers] = useState([])

    useEffect(() => {
        getDevelopers('/Developer/GetAllDevelopers', {
            method: 'GET',
            params: {
                showLayoffs: false
            }
        }).then((res) => {
            if (res.data.ok) {
                setDevelopers(res.data.result)
            }
        })
    }, [])

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const newArray = developers.map(item => {
                const rest = {
                    'Kişi Adı': item.fullName,
                    'Toplam İzin Hakkı': item.totalLeave,
                    'Kalan İzin Hakkı': item.remainingLeave
                }
                return rest
            })
            const workSheet = xlsx.utils.json_to_sheet(newArray)
            const workBook = { Sheets: { data: workSheet }, SheetNames: ['data'] }
            const excelBuffer = xlsx.write(workBook, {
                bookType: 'xlsx',
                type: 'array'
            })
            saveAsExcelFile(excelBuffer, 'leavesReport')
        })
    }

    const saveAsExcelFile = (buffer, fileName) => {

        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        let EXCEL_EXTENSION = '.xlsx'
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        })
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)

    }

    const renderHeader2 = () => {
        return (
            <div className='flex justify-content-between align-items-center'>
                <div className='heading-5'>İzin Yükü Raporu</div>
                <Button className='btn-success' handleClick={exportExcel} title="Excel'e Aktar" icon={<Icons.excel size={17} />} />
            </div>)
    }
    const header2 = renderHeader2()

    return (
        <AnimatedSpan className='page-container d-flex flex-column'>
            <div className='row-margin-x'>
                <div className='col-md-12'>
                    <DataTable
                        responsiveLayout='scroll'
                        loading={getDevelopersLoading}
                        header={header2}
                        className='p-1'
                        editMode='row'
                        dataKey='id'
                        stripedRows
                        value={developers}
                    >
                        <Column
                            className='text-semi-bold text-sm'
                            field='fullName'
                            style={{ width: 'auto' }}
                            header='Kişi Adı'
                            sortable='true'
                        />
                        <Column
                            className='text-semi-bold text-sm'
                            field='totalLeave'
                            style={{ width: 'auto' }}
                            header='Toplam İzin Hakkı'
                        />
                        <Column
                            className='text-semi-bold text-sm'
                            field='remainingLeave'
                            style={{ width: 'auto' }}
                            header='Kalan İzin Hakkı'
                        />
                    </DataTable>
                </div>
            </div>
        </AnimatedSpan>
    )
}

export default LeavesReport